<template>
<v-app>
    <v-main class="primary">
        <v-toolbar elevation="0" class="mb-2">
            <!-- <v-app-bar-nav-icon /> -->

            <v-layout row class="display-1 ml-2">
                <div id="font">
                    Simples
                </div>

                <div id="font" class="primary--text">
                    Medic
                </div>
            </v-layout>

            <v-spacer />
            <div>
                <v-card v-if="user.tecnico" class="rounded-xl" outlined>
                    <v-list-item>
                        <v-icon class="mr-2">
                            person
                        </v-icon>

                        <v-list-item-content>
                            <v-list-item-title v-text="user.usuario.nomeTratamento" />
                        </v-list-item-content>
                    </v-list-item>
                </v-card>
                <v-card v-else outlined class="rounded-xl">
                    <v-list-item>
                        <v-icon class="mr-2">
                            person
                        </v-icon>
                        <v-list-item-content>
                            <v-list-item-title v-text="'Dr(a). ' + user.usuario.nomeTratamento" />
                        </v-list-item-content>
                    </v-list-item>
                </v-card>
            </div>
            <v-btn title="Logout" text icon color="primary" @click="dialogLogout()">
                <v-icon v-if="user.tecnico" title="Logout">
                    logout
                </v-icon>
                <v-icon v-else title="Logout">
                    power_settings_new
                </v-icon>
            </v-btn>
        </v-toolbar>
        <v-layout column v-if="!cliente">
            <v-row align="center" justify="center">
                <v-col cols="12" md="6">
                    <v-card shaped flat height="625">
                        <v-card-title class="grey lighten-4">
                            <div class="blue--text text--darken-1">Pacientes</div>
                            <v-spacer />
                            <div>
                                <estatisticas />
                            </div>
                            <!-- <v-btn icon color="blue darken-1" dark @click="dialog = !dialog">
                                <v-icon>mdi-account-plus</v-icon>
                            </v-btn> -->
                        </v-card-title>

                        <v-card-text>
                            <v-text-field v-mask="mask" v-model="search" prepend-icon="mdi-magnify"></v-text-field>
                        </v-card-text>
                        <v-card flat class="overflow-y-auto mt-0 pt-0" max-height="445">
                            <v-list v-if="!loading">
                                <v-list-item-group>
                                    <v-list-item v-for="(paciente, index) in pacientes" :key="index" @click="cliente = paciente">
                                        <v-list-item-avatar>
                                            <v-icon>mdi-account</v-icon>
                                        </v-list-item-avatar>
                                        <v-list-item-content>
                                            <v-list-item-title><strong> {{ paciente.nomePaciente }} </strong> </v-list-item-title>
                                            <v-list-item-subtitle v-if="!paciente.cpf">CPF: <strong> ---.-- </strong></v-list-item-subtitle>
                                            <v-list-item-subtitle v-else>CPF: <strong class="indigo--text">{{ paciente.cpf.slice(0, 3) + '.' + paciente.cpf.slice(3) + '*.***-**' }} </strong></v-list-item-subtitle>
                                            <v-list-item-subtitle>Mãe: <strong>{{ paciente.nomeMae || '-----' }}</strong></v-list-item-subtitle>
                                            <v-list-item-subtitle>Data de Nascimento: <strong class="green--text">{{ paciente.dataNascimento ? formatarData(paciente.dataNascimento) : '-----' }}</strong></v-list-item-subtitle>
                                            <v-divider />
                                        </v-list-item-content>
                                    </v-list-item>
                                </v-list-item-group>
                                <v-alert v-if="!search" type="info" dismissible class="mx-2">
                                    Por favor, pesquise pelo cpf do paciente.
                                </v-alert>

                                <!-- <v-alert v-if="pacientes.length === 0 && search.length > 1" type="warning" class="mx-2" dismissible>
                                    Nenhum paciente encontrado.
                                </v-alert> -->
                            </v-list>
                            <v-skeleton-loader v-else height="100%" type="list-item-three-line"></v-skeleton-loader>
                            <div class="px-2">
                                <v-btn dark block color="blue" v-if="pacientes.length === 0 && search.length > 1" @click="dialog = !dialog">
                                    <v-icon>mdi-account-plus</v-icon>
                                    Cadastrar novo paciente.
                                </v-btn>
                            </div>
                        </v-card>
                    </v-card>
                </v-col>
            </v-row>
        </v-layout>

        <v-layout column v-else>
            <v-container :class="cliente == null ?'animated fadeOut': 'animated fadeIn'">
                <v-tabs v-model="tab" grow background-color="primary darken-3">
                    <v-tab>Solicitação Laboratorial</v-tab>
                    <v-tab>Solicitação</v-tab>
                </v-tabs>

                <v-tabs-items v-model="tab">
                    <v-tab-item>
                        <solicitacaoLaboratorial v-on:cancelar="cliente = null" v-on:solicitacoesCard="gerarVoucher" v-bind:paciente="cliente" v-bind:load="loadSolicitacao"></solicitacaoLaboratorial>
                    </v-tab-item>
                    <v-tab-item>
                        <solicitacao  v-on:cancelar="cliente = null" v-on:solicitacoesCard="gerarVoucher" v-bind:paciente="cliente" v-bind:load="loadSolicitacao"></solicitacao>
                    </v-tab-item>
                </v-tabs-items>
            </v-container>
        </v-layout>

        <v-snackbar v-model="cadastroSucesso" color="success">
            Paciente cadastrado com sucesso!
            <template v-slot:action="{ attrs }">
                <v-btn color="white" text v-bind="attrs" @click="cadastroSucesso = false">
                    Fechar
                </v-btn>
            </template>
        </v-snackbar>
        <template>
            <v-row justify="center">
                <v-dialog v-model="dialog" persistent max-width="700px">
                    <v-card>
                        <v-card-title>
                            <v-icon class="mr-4" color="blue darken-1">mdi-account-plus</v-icon>
                            <span class="text-h5 blue--text text--darken-1">Novo paciente</span>
                        </v-card-title>
                        <v-card-text>
                            <v-container>
                                <v-form ref="form" lazy-validation>
                                    <v-row>
                                        <v-col cols="12" sm="12" md="12">
                                            <v-text-field :rules="nameRules" v-model="usuario.nome" label="Nome completo" required></v-text-field>
                                        </v-col>
                                        <v-col cols="12" sm="12" md="12">
                                            <v-text-field :rules="telefoneRules" v-mask="'(##) #####-####'" v-model="usuario.celular" label="celular"></v-text-field>
                                        </v-col>
                                        <v-col cols="12" sm="5" md="5">
                                            <v-text-field :rules="nameRules" v-mask="'###.###.###-##'" v-model="usuario.cpf" label="CPF" persistent-hint required></v-text-field>
                                        </v-col>
                                        <!-- <v-col cols="12" sm="5" md="5">
                                        <v-text-field v-mask="'##/##/####'" v-model="usuario.dataNascimento" label="Data de nascimento" persistent-hint required></v-text-field>
                                    </v-col> -->
                                        <v-col cols="12" sm="5" md="5">
                                            <v-text-field :rules="nameRules" v-model="dateFormatted" v-mask="'##/##/####'" label="Data de nascimento" prepend-icon="mdi-calendar"></v-text-field>
                                            <!-- <div class="mb-6">Active picker: <code>{{ activePicker || 'null' }}</code></div> -->
                                            <!-- <v-menu ref="menu" v-model="menu" :close-on-content-click="false" transition="scale-transition" offset-y min-width="auto">
                                                <template v-slot:activator="{ on, attrs }">
                                                    <v-text-field :rules="nameRules" v-model="dateFormatted" label="Data de nascimento" prepend-icon="mdi-calendar" readonly v-bind="attrs" v-on="on"></v-text-field>
                                                </template>
                                                <v-date-picker :rules="nameRules" v-model="date" locale="pt-br" :active-picker.sync="activePicker" :max="(new Date(Date.now() - (new Date()).getTimezoneOffset() * 60000)).toISOString().substring(0, 10)" min="1950-01-01" @change="save"></v-date-picker>
                                            </v-menu> -->
                                        </v-col>
                                        <v-col cols="12" sm="2" md="2">
                                            <v-select :rules="nameRules" v-model="usuario.sexo" :items="['M', 'F']" label="Sexo" required></v-select>
                                        </v-col>
                                    </v-row>
                                </v-form>
                            </v-container>
                        </v-card-text>
                        <v-card-actions>
                            <v-spacer></v-spacer>
                            <v-btn :disabled="load" color="red darken-1" text @click="dialog = false">
                                <v-icon left>cancel</v-icon>
                                Cancelar
                            </v-btn>
                            <v-btn color="blue darken-1" :loading="load" text @click="cadastrarPaciente">
                                <v-icon left>save</v-icon>
                                Salvar
                            </v-btn>
                        </v-card-actions>
                    </v-card>
                </v-dialog>
            </v-row>

        </template>

    </v-main>
</v-app>
</template>

<script>
import medicoService from '../services/medico.service'
import nutricionistaService from '../services/nutricionistaService'
import solicitacaoLaboratorial from '../components/medico/solicitacaoLaboratorio'
import solicitacao from '../components/medico/solicitacao'
import posAtendimentoService from '../services/posAtendimento.service'
import estatisticas from '../components/nutricionista/estatisticas'
import moment from 'moment'
import {
  mask
} from 'vue-the-mask'

export default {
  directives: {
    mask
  },
  components: {
    solicitacaoLaboratorial,
    solicitacao,
    estatisticas
  },
  name: 'homeNutricionista',

  data () {
    return {
      activePicker: null,
      date: null,
      dateFormatted: '',
      menu: false,
      loadSolicitacao: false,
      cliente: null,
      tab: 0,
      usuario: {
        nome: '',
        celular: '',
        cpf: '',
        dataNascimento: '',
        sexo: ''
      },
      dialog: false,
      solicitacoesExamesLaboratoriais: [],
      idUnidadeNegocio: null,
      idPrestador: null,
      idMedico: null,
      pacientes: [],
      user: {},
      search: '',
      load: false,
      loading: false,
      nameRules: [
        v => !!v || 'Campo obrigatório'
      ],
      telefoneRules: [
        v => !!v || 'Telefone é obrigatório'
      ],
      cadastroSucesso: false,
      mask: '###.###.###-##'

      //   const [year, month, day] = date.split('-')
      //   return `${month}/${day}/${year}`
    }
  },
  methods: {
    cadastrarPaciente () {
      if (this.$refs.form.validate()) {
        this.load = true
        // nome, cpf, celular, dataNascimento, sexo
        medicoService.medico.cadastrarPacienteSimples(
          this.usuario.nome,
          this.unmask(this.usuario.cpf),
          this.unmask(this.usuario.celular),
          this.date,
          this.usuario.sexo
        ).then(
          response => {
            console.log(response)
            this.dialog = false
            this.usuario = {
              nome: '',
              celular: '',
              cpf: '',
              dataNascimento: ''
            }
            this.cadastroSucesso = true
            setTimeout(() => {
              this.cadastroSucesso = false
            }, 2000)
            // this.$toast.success('Paciente cadastrado com sucesso!')
          },
          error => {
            console.log(error)
            this.$toast.error('Erro ao cadastrar paciente!')
          }
        ).finally(() => {
          this.load = false
          this.dialog = false
        })
      }
    },
    save (date) {
      this.$refs.menu.save(date)
      // this.dateFormatted = this.formatDate(date)
    },
    unmask (str) {
      return str.replace(/[^\d]/g, '')
    },
    parseDate (date) {
      if (!date) return null

      const [month, day, year] = date.split('/')
      return `${year}-${month.padStart(2, '0')}-${day.padStart(2, '0')}`
    },
    inserirAtendimento (idMedico, os) {
      nutricionistaService.nutricionista.inserirAtendimento(idMedico, os).then(r => {
        if (r.status === 200 && !r.data.error) {
          this.$toast.success('Atendimento inserido com sucesso!')
        } else {
          this.$toast.error('Erro ao inserir atendimento!')
        }
      })
    },

    consultarOrcamentoExamesLaboratoriais (solicitacoesExamesLaboratoriais) {
      var exames = []
      var orcamentoExamesLaboratoriais = 0
      for (let i = 0; i < solicitacoesExamesLaboratoriais.length; i++) {
        const e = solicitacoesExamesLaboratoriais[i]
        exames.push(e.idExame)
      }
      return posAtendimentoService.consultarOrcamento({
        idEmpresa: 1,
        exames: exames
      }).then(r => {
        if (r.status === 200) {
          for (let i = 0; i < r.data.length; i++) {
            const e = r.data[i]
            for (let j = 0; j < solicitacoesExamesLaboratoriais.length; j++) {
              const ex = solicitacoesExamesLaboratoriais[j]
              if (e.id === ex.idExame) {
                orcamentoExamesLaboratoriais = orcamentoExamesLaboratoriais + e.valor
                ex.valor = e.valor
              }
            }
          }
          orcamentoExamesLaboratoriais = orcamentoExamesLaboratoriais.toLocaleString('pt-BR', {
            style: 'currency',
            currency: 'BRL'
          })
        }
        return orcamentoExamesLaboratoriais
      }).finally(() => {
        this.loadMoney = false
      })
    },
    async gerarVoucher (solicitacoesExamesLaboratoriais, sadt) {
      this.loadSolicitacao = true
      var exames = []
      var solicitacoes = solicitacoesExamesLaboratoriais

      solicitacoes.forEach(e => {
        exames.push({
          id: e.idExame
        })
      })
      // console.log('-------->  ', solicitacoes)
      var orcamentoExames = 0
      orcamentoExames = await this.consultarOrcamentoExamesLaboratoriais(solicitacoes)
      // console.log('orcamentoExames: ', orcamentoExames)
      this.loadSolicitacao = true
      // else if (this.user.idEmpresa == 11) {
      //      this.idUnidadeNegocio = 295;
      posAtendimentoService.gerarVoucher({
        exames: exames,
        idEmpresa: 11,
        idUnidadeNegocio: 295,
        idConvenio: this.user.usuario.voucher.idConvenio,
        tipoSolicitacao: sadt ? 'LABORATORIO' : 'SADT',
        idPaciente: this.cliente.idPaciente,
        idPrestadorSolicitante: this.user.usuario.idExternoPrestador, // id do medico
        idUsuario: this.user.usuario.idExternoUser,
        armazenado: false,
        obs: ''
      }).then(r => {
        console.log(r)
        if (r.status === 200 && !r.data.error) {
          console.log(r.data)
          if (r.data.msg === 'sucesso') {
            var exames = []
            var total = 0
            var solicitacoes = solicitacoesExamesLaboratoriais
            solicitacoes.forEach(e => {
              total += e.valor != null ? total + e.valor : total
              exames.push({
                nome: e.nomeExame,
                valor: e.valor != null ? e.valor : 0
              })
            })
            var receituario = {
              exames: exames,
              paciente: '',
              atendimento: orcamentoExames,
              os: r.data.idOS,
              medicamentos: '',
              solicitante: exames.length,
              tipo: 'voucherLaboratorio',
              // exames: solicitacao,
              descricao: ''

            }
            // this.inserirAtendimento(this.user.usuario.id, r.data.idOS)
            posAtendimentoService.downloadRelatorioVoucher(receituario).then(r => {
              const url = window.URL.createObjectURL(new Blob([r.data]))
              const link = document.createElement('a')
              link.href = url
              link.setAttribute('download', `${r.data.idOS}.pdf`)
              document.body.appendChild(link)
              link.click()
            })
          }

          // this.listaExamesSolicitados = [];
        } else {
          this.loadSolicitacao = false
          this.erroVoucher = r.data.msg
          setTimeout(() => {
            this.erroVoucher = ''
          }, 5000)
        }
      }).finally(() => {
        this.dialog = false
        this.loadSolicitacao = false
      })
    },

    nomeFormatado (str) {
      var arr = str.split(' ')
      if (arr[1] != null) {
        var preposicao = arr[1].toLowerCase()
        if (
          preposicao === 'de' ||
                    preposicao === 'da' ||
                    preposicao === 'das' ||
                    preposicao === 'do' ||
                    preposicao === 'dos'
        ) {
          preposicao = true
        } else {
          preposicao = false
        }
      }
      return arr.slice(0, preposicao ? 3 : 2).join(' ')
    },
    formatarData (data) {
      return moment(data).format('DD/MM/YYYY')
    },
    dialogLogout () {
      this.logout()
    },
    logout () {
      console.log('em logout..')
      // this.$router.push("/login");
      this.$store
        .dispatch('FedLogOut')
        .then(rsp => {
          this.$router.push('/login')
          if (rsp) {}
        })
        .catch(error => {
          console.log(error)
        })
    },
    buscarPacientes (cpf) {
      this.loading = true
      medicoService.medico.filtrarPacientesPorCpf(cpf).then(
        response => {
          this.pacientes = response.data
          this.loading = false
        },
        error => {
          console.log(error)
          this.loading = false
        }
      )
    },
    removerPontosEHifens (string) {
      // Use a função replace com uma expressão regular para remover pontos e hifens
      return string.replace(/[.-]/g, '')
    }
  },
  mounted () {
    this.user = this.$store.state.user
  },

  watch: {
    //  solicitacoesExamesLaboratoriais (val) {
    //    if (this.examesLaboratoriais.length > 0) {
    //      this.consultarOrcamentoExamesLaboratoriais()
    //    }
    // },
    menu (val) {
      val && setTimeout(() => (this.activePicker = 'YEAR'))
    },
    search: function (val) {
      var cpf = this.removerPontosEHifens(val)
      if (cpf.length > 1) {
        this.buscarPacientes(cpf)
      } else {
        this.pacientes = []
      }
    }
  }
}
</script>

<style scoped>
.blue-background {
    background-color: primary;
}
</style>
